export const SET_HRES72U_INDEX_DISP = 'SET_HRES72U_INDEX_DISP'
export const GET_HRES72U_INDEX_DISP = 'GET_HRES72U_INDEX_DISP'
export const SET_HRES72U_DETAIL_DISP = 'SET_HRES72U_DETAIL_DISP'
export const GET_HRES72U_DETAIL_DISP = 'GET_HRES72U_DETAIL_DISP'
export const SET_HRES72U_MAX_ROWSPAN = 'SET_HRES72U_MAX_ROWSPAN'
export const GET_HRES72U_MAX_ROWSPAN = 'GET_HRES72U_MAX_ROWSPAN'
export const SET_HRES72U_COLUMNS = 'SET_HRES72U_COLUMNS'
export const GET_HRES72U_COLUMNS = 'GET_HRES72U_COLUMNS'
export const SET_HRES72U_LABELS = 'SET_HRES72U_LABELS'
export const GET_HRES72U_LABELS = 'GET_HRES72U_LABELS'
export const RECEIVED_HRES72U_COLUMNS_LABELS = 'RECEIVED_HRES72U_COLUMNS_LABELS'
export const SET_HRES72U_INDEX = 'SET_HRES72U_INDEX'
export const GET_HRES72U_INDEX = 'GET_HRES72U_INDEX'
export const RECEIVED_HRES72U_INDEX = 'RECEIVED_HRES72U_INDEX'
export const SET_HRES72U_INDEX_SELECTED = 'SET_HRES72U_INDEX_SELECTED'
export const GET_HRES72U_INDEX_SELECTED = 'GET_HRES72U_INDEX_SELECTED'
export const SET_HRES72U_DETAIL = 'SET_HRES72U_DETAIL'
export const GET_HRES72U_DETAIL = 'GET_HRES72U_DETAIL'
export const RECEIVED_HRES72U_DETAIL = 'RECEIVED_HRES72U_DETAIL'
export const TOGGLE_HRES72U_PAGE = 'TOGGLE_HRES72U_PAGE'
export const POST_HRES72U_SEND_APPROVE = 'POST_HRES72U_SEND_APPROVE'
export const GET_HRES72U_DETAIL_TAB2_POPUP = 'GET_HRES72U_DETAIL_TAB2_POPUP'
export const SET_HRES72U_DETAIL_TAB2_POPUP = 'SET_HRES72U_DETAIL_TAB2_POPUP'
export const RECEIVED_HRES72U_DETAIL_TAB2_POPUP = 'RECEIVED_HRES72U_DETAIL_TAB2_POPUP'

export const SET_HRES72U_DETAIL_SUBMIT = 'SET_HRES72U_DETAIL_SUBMIT'
export const GET_HRES72U_DETAIL_SUBMIT = 'GET_HRES72U_DETAIL_SUBMIT'
export const RECEIVED_HRES72U_DETAIL_SUBMIT = 'RECEIVED_HRES72U_DETAIL_SUBMIT'



// WEBPACK FOOTER //
// ./src/store/modules/hres72u/mutation-types.js